/**
 * Optional dev/demo one-click login fill.
 *
 * Shown when:
 * - `vite` dev server (`import.meta.env.DEV`), or
 * - build had `VITE_LOGIN_QUICK_FILL=true` (e.g. docker compose build args), or
 * - the page is opened on localhost / 127.0.0.1 / ::1 (so nginx + Docker static
 *   bundles on `http://127.0.0.1:5174` still get the button without a special rebuild).
 */
function isLoopbackHost(): boolean {
  if (typeof window === 'undefined') return false;
  const h = window.location.hostname;
  return h === 'localhost' || h === '127.0.0.1' || h === '[::1]';
}

export function isLoginQuickFillEnabled(): boolean {
  return Boolean(
    import.meta.env.DEV ||
      import.meta.env.VITE_LOGIN_QUICK_FILL === 'true' ||
      isLoopbackHost(),
  );
}

export function getAdminQuickLoginDefaults(): { username: string; password: string } {
  return {
    username: import.meta.env.VITE_DEV_ADMIN_USERNAME ?? 'admin',
    password: import.meta.env.VITE_DEV_ADMIN_PASSWORD ?? 'ChangeMeOnFirstLogin!',
  };
}
